import React from "react";

import { useModalContext } from "./ModalContext";

const Header = ({
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  const { closeModal } = useModalContext();
  return (
    <div className="flex justify-between" {...props}>
      <span className="text-2xl font-bold md:text-2xl">{children}</span>
      <div className="ml-2 mt-1">
        <button
          className="ml-auto h-7 w-7 place-self-center rounded-full bg-[#E8E8E8]"
          onClick={closeModal}
        >
          <span className="text-xl font-semibold text-[#979797]">×</span>
        </button>
      </div>
    </div>
  );
};

export default Header;
